<template>
  <div class="w-full">
    <div class="flex items-center gap-3">
      <button
        class="flex items-center gap-2 text-sm uppercase tracking-widest font-medium
               border border-lh_light_gray px-3 py-1.5 rounded
               hover:border-lh_red hover:text-lh_red transition-colors dark:border-gray-400 dark:hover:border-lh_red"
        @click="showPanel = !showPanel"
      >
        <FunnelIcon class="w-4 h-4" />
        {{ $t('frontoffice.products.filters') }}
        <ChevronDownIcon class="w-3 h-3 transition-transform duration-200" :class="{ 'rotate-180': showPanel }" />
      </button>

    </div>

    <div
      v-show="showPanel"
      class="mt-3 border border-lh_light_gray dark:border-gray-600 rounded-lg
             bg-white dark:bg-lh_gray divide-y divide-lh_light_gray dark:divide-gray-600"
    >
      <!-- Brand / Compatibility -->
      <div class="px-4 py-3">
        <button
          class="w-full flex items-center justify-between font-medium text-sm uppercase tracking-widest"
          @click="openSection = openSection === 'brand' ? null : 'brand'"
        >
          <span>{{ $t('frontoffice.products.brand') }}</span>
          <!-- eslint-disable-next-line max-len -->
          <ChevronDownIcon class="w-3 h-3 transition-transform duration-200" :class="{ 'rotate-180': openSection === 'brand' }" />
        </button>
        <div v-show="openSection === 'brand'" class="mt-3">
          <ais-refinement-list
            attribute="COMPATIBILITA"
            :transform-items="divideLabel"
            :class-names="{
              'ais-RefinementList-checkbox': checkboxClasses,
              'ais-RefinementList-noResults': 'dark:text-white text-sm italic',
            }"
          />
        </div>
      </div>

      <!-- Mechanism -->
      <div class="px-4 py-3">
        <button
          class="w-full flex items-center justify-between font-medium text-sm uppercase tracking-widest"
          @click="openSection = openSection === 'harp' ? null : 'harp'"
        >
          <span>Mechanism</span>
          <!-- eslint-disable-next-line max-len -->
          <ChevronDownIcon class="w-3 h-3 transition-transform duration-200" :class="{ 'rotate-180': openSection === 'harp' }" />
        </button>
        <div v-show="openSection === 'harp'" class="mt-3">
          <ais-refinement-list
            attribute="HARP"
            :transform-items="transformHarp"
            :class-names="{
              'ais-RefinementList-checkbox': checkboxClasses,
              'ais-RefinementList-noResults': 'dark:text-white text-sm italic',
            }"
          />
        </div>
      </div>

      <!-- Subcategory -->
      <div class="px-4 py-3">
        <button
          class="w-full flex items-center justify-between font-medium text-sm uppercase tracking-widest"
          @click="openSection = openSection === 'sub' ? null : 'sub'"
        >
          <span>{{ $t('frontoffice.products.subcategory') }}</span>
          <!-- eslint-disable-next-line max-len -->
          <ChevronDownIcon class="w-3 h-3 transition-transform duration-200" :class="{ 'rotate-180': openSection === 'sub' }" />
        </button>
        <div v-show="openSection === 'sub'" class="mt-3">
          <ais-refinement-list
            attribute="productSubcategoryName"
            :class-names="{
              'ais-RefinementList-checkbox': checkboxClasses,
              'ais-RefinementList-noResults': 'dark:text-white text-sm italic',
            }"
          />
        </div>
      </div>

      <!-- Reset -->
      <div class="px-4 py-3">
        <ais-clear-refinements>
          <template v-slot="{ canRefine, refine }">
            <button
              :disabled="!canRefine"
              @click.prevent="refine"
              class="text-xs uppercase tracking-widest transition-colors"
              :class="canRefine ? 'text-lh_gold underline' : 'text-gray-300 dark:text-gray-600 cursor-not-allowed'"
            >
              {{ $t('filters.resetFilters') }}
            </button>
          </template>
        </ais-clear-refinements>
      </div>
    </div>
  </div>
</template>

<script>
import { AisRefinementList, AisClearRefinements } from 'vue-instantsearch/vue3/es';
import { FunnelIcon, ChevronDownIcon } from '@heroicons/vue/24/outline';

export default {
  components: {
    AisRefinementList,
    AisClearRefinements,
    FunnelIcon,
    ChevronDownIcon,
  },
  data() {
    return {
      showPanel: false,
      openSection: null,
      harpOptions: {
        Lever: this.$t('frontoffice.products.lever'),
        Pedal: this.$t('frontoffice.products.pedal'),
      },
    };
  },
  computed: {
    checkboxClasses() {
      return 'bg-transparent border-gray-400 dark:border-gray-100 dark:checked:border-lh_red checked:border-lh_red';
    },
  },
  methods: {
    divideLabel(items) {
      return items.map((item) => ({
        ...item,
        label: item.label.replaceAll('_', ' '),
      }));
    },
    transformHarp(items) {
      return items.map((item) => ({
        ...item,
        label: this.harpOptions[item.value] || item.value,
      }));
    },
  },
};
</script>
